@if (!isNavHidden) {
  <div
    role="region"
    aria-label="Toolbar Section"
    data-test-id="toolbarSection"
    #toolbarContainerRef
  >
    @if (!!navigationService.config.toolbar) {
      <toolbar
        data-test-id="navigationToolbar"
        [isLoggedIn]="isLoggedIn"
        [notifications]="notifications"
        (logoClicked)="logoClicked()"
        (buttonClicked)="onNavButtonClick($event)"
      >
      </toolbar>
    } @else {
      <tablet-toolbar
        class="nav__tablet-toolbar"
        data-test-id="navigationTabletToolbar"
      ></tablet-toolbar>
    }
  </div>
  <mobile-menu
    [isLoggedIn]="isLoggedIn"
    (openContactModal)="navigationService.openContactModal()"
    (handleLogout)="handleLogout()"
    data-test-id="mobileMenu"
  ></mobile-menu>
  <nav
    class="nav"
    aria-label="Navigation Section"
    data-test-id="navigationSection"
    [ngClass]="{
      'nav--alt':
        !!navigationService.config.navAlt || !!navigationService.config.toolbar,
      'display-none':
        !!navigationService.config.hideNavWhenLoggedOut && !isLoggedIn,
    }"
  >
    <div class="container">
      <div class="u-flex">
        @if (navigationService.config.showHamburger) {
          <div class="Nav__Toggle">
            <icon
              class="HamburgerIcon__Tablet"
              name="hamburger"
              data-test-id="hamburgerTabletIcon"
              [config]="{
                fill:
                  navigationService.config.icons?.fill ||
                  'btn-medium__icon--resting',
                type: 'pointer',
              }"
              (click)="navigationService.toggleMobileMenu()"
            ></icon>
            <icon
              class="HamburgerIcon__Mobile"
              name="hamburger"
              data-test-id="hamburgerMobileIcon"
              [config]="{
                fill: 'menu__icon-color--mobile' || 'btn-medium__icon--resting',
                type: 'pointer',
              }"
              (click)="navigationService.toggleMobileMenu()"
            ></icon>
          </div>
        }
        @if (!navigationService.config.showLogoInToolbar) {
          <span
            (click)="logoClicked()"
            class="nav__logo"
            data-test-id="navigationLogo"
            tabindex="0"
            [attr.aria-label]="navigationService.config.alt"
          >
          </span>
        }
        @if (
          navigationService.config.showImage &&
          !navigationService.config.showLogoInToolbar
        ) {
          <img
            class="nav__image"
            [src]="navigationService.config.imageLink"
            alt="Navigation"
            data-test-id="navigationLogo"
          />
        }
        @if (isLoggedIn) {
          <section
            class="nav__links"
            [ngClass]="{
              links__padding:
                navigationService.config.showImage &&
                navigationService.config.showLogoInToolbar,
            }"
          >
            @for (
              link of navigationService.config.links;
              track link;
              let i = $index
            ) {
              <div
                class="nav__link"
                [ngClass]="{
                  'is-open': !!link.items && !!link.open,
                  'is-active': navigationService.isActiveRoute(link.route),
                }"
              >
                @if (!!link.route) {
                  <a
                    class="t-data"
                    [attr.aria-label]="'navigate to ' + link.route"
                    (click)="navigationService.selectNavLink($event, link)"
                    [data-test-id]="'navigationRoute' + i"
                    [routerLink]="link.route"
                    [queryParams]="queryParams"
                  >
                    {{ link.label }}
                  </a>
                }
                @if (!!link.link) {
                  <a
                    class="t-data"
                    [href]="link.link"
                    [attr.aria-label]="'navigate to ' + link.link"
                    [data-test-id]="'navigationLink' + i"
                    [target]="link.target || '_blank'"
                  >
                    {{ link.label }}
                  </a>
                }
                @if (!!link.items) {
                  <div
                    class="u-flex"
                    (click)="navigationService.selectNavLink($event, link)"
                  >
                    <p class="t-data" [data-test-id]="'navigationLinkItem' + i">
                      {{ link.label }}
                    </p>
                    <i
                      class="icon icon--medium"
                      [data-test-id]="'navigationLinkIcon' + i"
                      [ngClass]="{ 'icon--rotate180': !!link.open }"
                    >
                      chevron_down
                    </i>
                  </div>
                }
                @if (!!link.items && !!link.open) {
                  <div
                    class="nav__link__menu"
                    (libOutsideClick)="closeLink(link)"
                  >
                    @for (
                      item of link.items;
                      track item;
                      let linkItemIndex = $index
                    ) {
                      <div>
                        @if (!!item.route) {
                          <div>
                            <a
                              class="nav__link__menu__item"
                              [routerLink]="item.route"
                              (click)="closeLink(link)"
                              [data-test-id]="
                                'navigationLinkItemRoute' + linkItemIndex
                              "
                              [queryParams]="queryParams"
                              [attr.aria-label]="'navigate to ' + item.route"
                            >
                              <i
                                class="icon icon--medium"
                                [data-test-id]="
                                  'navigationLinkItemIcon' + linkItemIndex
                                "
                                >{{ item.icon }}</i
                              >
                              <div>
                                <p
                                  class="t-data"
                                  [data-test-id]="
                                    'navigationLinkItemLabel' + linkItemIndex
                                  "
                                >
                                  {{ item.label }}
                                </p>
                                <p
                                  class="t-data t-alt"
                                  [data-test-id]="
                                    'navigationLinkItemDescription' +
                                    linkItemIndex
                                  "
                                >
                                  {{ item.description }}
                                </p>
                              </div>
                            </a>
                          </div>
                        }
                        @if (!!item.externalLink) {
                          <div>
                            <a
                              class="nav__link__menu__item"
                              href="{{ item.externalLink }}{{
                                queryParams.member_id
                              }}/cxengine/"
                              target="_blank"
                              [data-test-id]="
                                'navigationExternalLink' + linkItemIndex
                              "
                              [attr.aria-label]="
                                'navigate to ' + link.externalLink
                              "
                            >
                              <i
                                class="icon icon--medium"
                                [data-test-id]="
                                  'navigationExternalLinkIcon' + linkItemIndex
                                "
                                >{{ item.icon }}</i
                              >
                              <div>
                                <p
                                  class="t-data"
                                  [data-test-id]="
                                    'navigationExternalLinkLabel' +
                                    linkItemIndex
                                  "
                                >
                                  {{ item.label }}
                                </p>
                                <p
                                  class="t-data t-alt"
                                  [data-test-id]="
                                    'navigationExternalLinkDescription' +
                                    linkItemIndex
                                  "
                                >
                                  {{ item.description }}
                                </p>
                              </div>
                            </a>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </section>
        }
        @if (
          navigationService.config.icons &&
          !!navigationService.config.icons.mobile &&
          !navigationService.config.hideUtilityLinksInNavBar
        ) {
          <section class="nav__icons nav__icons--mobile">
            @for (
              tool of navigationService.config.icons.mobile;
              track tool;
              let i = $index
            ) {
              @if (IsNavIconDisplay(tool)) {
                <a
                  class="nav__link"
                  [ngClass]="{
                    'is-active': navigationService.isActiveRoute(tool.route),
                  }"
                  [routerLink]="tool.route"
                  [attr.aria-label]="'navigate to ' + tool.route"
                  [data-test-id]="'navigationMobileRoute' + i"
                  (click)="navigationService.selectNavLink($event, tool)"
                >
                  <i
                    class="icon icon--medium"
                    [data-test-id]="'navigationMobileItemIcon' + i"
                    >{{
                      !!navigationService.isActiveRoute(tool.route)
                        ? tool.icon + '_active'
                        : tool.icon
                    }}</i
                  >
                  @switch (tool.count) {
                    @case ('notifications') {
                      @if (notifications > 0) {
                        <span
                          class="nav__link-count t-caption u-flex u-alignCenter u-justifyCenter"
                          [data-test-id]="'navigationMobileNotification' + i"
                          >{{ notifications }}</span
                        >
                      }
                    }
                  }
                </a>
              }
            }
          </section>
        }
        @if (
          navigationService.config.icons &&
          !!navigationService.config.icons.desktop &&
          !navigationService.config.hideUtilityLinksInNavBar
        ) {
          <section class="nav__icons nav__icons--desktop">
            @for (
              tool of navigationService.config.icons.desktop;
              track tool;
              let i = $index
            ) {
              <a
                data-tooltip="Notifications"
                class="nav__link tooltip"
                [ngClass]="{
                  'is-active': navigationService.isActiveRoute(tool.route),
                }"
                [routerLink]="tool.route"
                [attr.aria-label]="'navigate to ' + tool.route"
                (click)="navigationService.selectNavLink($event, tool)"
                [data-test-id]="'navigationDesktopRoute' + i"
              >
                <i
                  class="icon icon--medium"
                  [data-test-id]="'navigationDesktopItemIcon' + i"
                  >{{
                    !!navigationService.isActiveRoute(tool.route)
                      ? tool.icon + '_active'
                      : tool.icon
                  }}</i
                >
              </a>
            }
          </section>
        }
        @if (
          !!navigationService.config.buttons &&
          !navigationService.config.hideUtilityLinksInNavBar
        ) {
          <section
            class="nav__utility-links u-flex u-alignCenter u-justifyEnd u-fillRemaining"
          >
            <div class="button__group">
              @if (
                navigationService.config.showBrokerName &&
                !!authService.loggedInUser
              ) {
                <h6 data-test-id="userName">
                  {{
                    !!authService.loggedInUser?.app_user_data?.first_name
                      ? authService.loggedInUser.app_user_data.first_name
                      : ''
                  }}
                </h6>
              }
              @for (
                button of navigationService.config.buttons;
                track button;
                let i = $index
              ) {
                @if (button.type === 'auth') {
                  @if (isButtonVisible(button, 'billing')) {
                    @if (
                      authService.loggedInUser &&
                      authService.loggedInUser.app_user_data
                    ) {
                      <zip-button
                        class="nav__icons--desktop"
                        (zipButtonClicked)="handleLogout()"
                        z
                        [data-test-id]="'logoutButton' + i"
                        [level]="button.level || 'medium'"
                        [content]="button.logout || 'Log Out'"
                      >
                      </zip-button>
                    } @else {
                      @if (
                        !button.hideRegisterbutton &&
                        isButtonVisible(button, 'register')
                      ) {
                        <zip-button
                          class="nav__icons--desktop"
                          (zipButtonClicked)="handleRegister()"
                          [level]="button.level || 'medium'"
                          [data-test-id]="'registerButton' + i"
                          [content]="button.register || 'Register'"
                        >
                        </zip-button>
                      }
                      @if (isButtonVisible(button, 'login')) {
                        <zip-button
                          class="nav__icons--desktop"
                          (zipButtonClicked)="handleLogin()"
                          [level]="button.level || 'medium'"
                          [data-test-id]="'loginButton' + i"
                          [content]="button.login || 'Log In'"
                        >
                        </zip-button>
                      }
                    }
                  }
                } @else {
                  @if (button.onClick) {
                    <zip-button
                      class="nav__icons--desktop"
                      (zipButtonClicked)="onNavButtonClick(button)"
                      [level]="button.level"
                      [content]="button.content"
                      [data-test-id]="'defaultButton' + i"
                    >
                    </zip-button>
                  }
                  @if (button.link) {
                    <a
                      [href]="button.link"
                      [attr.aria-label]="'navigate to ' + button.link"
                      target="_blank"
                      [data-test-id]="'buttonLink' + i"
                    >
                      <zip-button
                        [level]="button.level"
                        [content]="button.content"
                        [data-test-id]="'linkButton' + i"
                      ></zip-button>
                    </a>
                  }
                  @if (button.route) {
                    <a
                      [routerLink]="button.route"
                      [data-test-id]="'routeLink' + i"
                      [attr.aria-label]="'navigate to ' + button.route"
                      [queryParams]="button.queryParams"
                    >
                      @if (isButtonVisible(button)) {
                        <zip-button
                          [level]="button.level"
                          [content]="button.content"
                          [data-test-id]="'navButton' + i"
                          (zipButtonClicked)="onNavButtonClick(button)"
                        ></zip-button>
                      }
                    </a>
                  }
                }
              }
            </div>
          </section>
        }
      </div>
    </div>
  </nav>
}

<modal
  [config]="navigationService.contactUsModalConfig"
  [condition]="navigationService.contactUsModalOpen"
  (cancel)="navigationService.closeContactModal()"
>
  <div [zipBusy]="brokerSearchSub" class="contact--modal" body>
    @if (navigationService.contactUsConfig?.title) {
      <h4 class="t-bold" data-test-id="contactUsModalTitle">
        {{ navigationService.contactUsConfig?.title }}
      </h4>
    }

    @for (
      contactGroup of navigationService.contactGroups;
      track contactGroup;
      let i = $index
    ) {
      <div>
        <div class="section--title">
          @if (contactGroup.icon) {
            <i
              class="icon icon--medium t-bold"
              data-test-id="contactGroupIcon"
              >{{ contactGroup.icon }}</i
            >
          }
          <h6 class="t-bold" data-test-id="contactGroupHeader">
            {{ contactGroup.header }}
          </h6>
        </div>
        <div class="SectionContent">
          @for (contact of contactGroup.contacts; track contact) {
            <div class="SectionContacts">
              <p
                class="SectionContacts__Label t-data t-bold"
                [innerHTML]="contact.header"
              ></p>
              <div class="SectionContacts__Value">
                @for (detail of contact.details; track detail; let i = $index) {
                  <p class="SectionContacts__Data t-data">
                    @if (['phone', 'email'].includes(detail.type)) {
                      <a
                        [href]="
                          detail.type === 'phone'
                            ? 'tel:' + (detail.data | phoneNumber)
                            : 'mailto:' + detail.data
                        "
                        (click)="sendDataAnalytics(detail)"
                        [data-test-id]="'contactInfo' + i"
                        [innerHTML]="
                          detail.type === 'phone'
                            ? (detail.data | phoneNumber)
                            : detail.data
                        "
                      >
                      </a>
                    } @else {
                      <p
                        [innerHTML]="detail.data"
                        [data-test-id]="'contactNoLinkText' + i"
                      ></p>
                    }
                  </p>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</modal>
